module.exports = __webpack_public_path__ + "static/img/ksrk_logo3.146ed2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/官网首页/firstlink/ksrk_logo3.png
// module id = iAWE
// module chunks = 1